export const RESET_QUESTIONNAIRE = 'RESET_QUESTIONNAIRE';

export function resetQuestionnaire() {
  return dispatch => dispatch({
    type: RESET_QUESTIONNAIRE,
  });
}
